export interface CurrentFindingsDataset {
  label: string;
  provider?: string;
  data: number[];
}

const hasNonZeroCount = (dataset: CurrentFindingsDataset) =>
  dataset.data.some((count) => count > 0);

const mergeDatasetCounts = (datasets: CurrentFindingsDataset[]) => {
  const countLength = datasets[0]?.data.length || 0;
  return Array.from({ length: countLength }, (_, index) =>
    datasets.reduce((total, dataset) => total + (dataset.data[index] || 0), 0),
  );
};

/**
 * Match the endpoint dashboard's current-chart behavior: omit empty source
 * datasets and prepend an aggregate ring only when multiple sources remain.
 */
export const buildCurrentFindingsDatasets = (
  datasets: CurrentFindingsDataset[],
): CurrentFindingsDataset[] => {
  const nonEmptyDatasets = datasets.filter(hasNonZeroCount);
  if (nonEmptyDatasets.length <= 1) return nonEmptyDatasets;

  return [
    {
      label: 'All',
      data: mergeDatasetCounts(nonEmptyDatasets),
    },
    ...nonEmptyDatasets,
  ];
};

export const getAggregateCounts = (datasets: CurrentFindingsDataset[]) => {
  const providerDatasets = datasets.filter(
    (dataset) => dataset.provider !== undefined,
  );
  if (providerDatasets.length > 0) return mergeDatasetCounts(providerDatasets);
  return datasets[0]?.data || [];
};
